import { type PropsWithChildren } from 'react'
import { Stack } from '../../primitives/Stack'
import { Divider } from '../../primitives/Divider'
import { useCard } from './use-card'

type Props = PropsWithChildren<{
  isFullscreen?: boolean
}>

export const BaseCardFooter = ({ children, isFullscreen }: Props) => {
  const { isDense, spacingToken, isMobile, hasDividerBottom } = useCard()

  return (
    <>
      {hasDividerBottom && <Divider />}
      <Stack
        direction={isMobile ? 'column' : 'row'}
        sx={{
          ...(!isFullscreen && {
            px: isDense ? 2 : spacingToken,
            pt: hasDividerBottom ? 1.5 : 0,
            pb: 1.5,
          }),
          gap: 2,
          justifyContent: 'flex-end',
        }}
      >
        {children}
      </Stack>
    </>
  )
}
